export const KIRCHGELD_ALLGEMEIN = 'KirchgeldAllgemein'

export const letterAssignmentTypes = [
  {
    label: 'Kirchgeld allgemein',
    value: KIRCHGELD_ALLGEMEIN
  },
]
